export default "__VITE_ASSET__I1Jhbjmv__"